import React from "react";

// reactstrap components
import { Button, Container } from "reactstrap";

// core components

function LandingPageHeader() {
  let pageHeader = React.createRef();

  // React.useEffect(() => {
  //   if (window.innerWidth > 100) {
  //     const updateScroll = () => {
  //       let windowScrollTop = window.pageYOffset / 3;
  //       pageHeader.current.style.transform =
  //         "translate3d(0," + windowScrollTop + "px,0)";
  //     };
  //     window.addEventListener("scroll", updateScroll);
  //     return function cleanup() {
  //       window.removeEventListener("scroll", updateScroll);
  //     };
  //   }
  // });

  return (
    <>
      {/* <div
        className="page-header"
        ref={pageHeader}
        style={{
          background:
          "linear-gradient(182deg,rgba(48, 32, 82, 1) 0%, rgba(97, 82, 135, 1) 50%, rgba(142, 129, 179, 1) 100%)",
        }}
      > */}
      <div
        className="page-header"
        ref={pageHeader}
        style={{
          backgroundImage: "url(" + require("assets/img/stars.jpeg") + ")",
        }}
      >
        <div className="filter" />
        <div className="content-center">
          <Container>
            <div className="motto">
              <img
                alt="Midshot of Shannen looking to the right side of the frame with hand on hip. They are tan with short black hair, wearinf black sweater."
                src={require("assets/img/main-headshot.jpg")}
                width={250}
                height={360}
              />
              <h1 className="title">SHANNEN VELASCO</h1>
              <h3>Actor | Voice Over, Film</h3>
              <br />
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default LandingPageHeader;
